var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isShow)?_c('div',{staticClass:"page-wrapper page-fixed page-overflow-hidden select"},[_c('div',{staticClass:"page-background-color-white page-absolute",class:{'animationToTop': _vm.animationToTop},style:(_vm.contentStyle)},[_vm._t("default")],2),_c('div',{staticClass:"page-absolute mark",on:{"click":_vm.close}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }